import { defineAction } from 'redux-define';
const SET = 'SET';
const GET = 'GET';
const EXPIRE = 'EXPIRE';
const REMOVE = 'REMOVE';

const REDUX_COOKIES = defineAction(
  'REDUX_COOKIES',
  [SET, GET, EXPIRE, REMOVE],
  'claro/Video',
);

export const getCookie = name => ({ type: REDUX_COOKIES.GET, name });

export const setCookie = (name, value, options = {}) => ({
  type: REDUX_COOKIES.SET,
  name,
  value,
  options,
});

export const expireCookie = name => ({ type: REDUX_COOKIES.EXPIRE, name });

export const removeCookie = (name, options) => ({
  type: REDUX_COOKIES.REMOVE,
  name,
  options,
});

export const createCookieMiddleware = cookies => {
  const actions = {};

  actions[REDUX_COOKIES.GET] = action => {
    try {
      return cookies.get(action.name);
    } catch (e) {
      return undefined;
    }
  };

  actions[REDUX_COOKIES.SET] = action =>
    cookies.set(action.name, action.value, action.options);

  actions[REDUX_COOKIES.EXPIRE] = action => cookies.set(action.name, undefined);

  actions[REDUX_COOKIES.REMOVE] = action => {
    if (cookies.remove) {
      return cookies.remove(action.name, action.options);
    }
    return cookies.set(action.name, undefined);
  };

  return () => next => action => {
    const currentActionHandler = actions[action.type];
    if (currentActionHandler) return currentActionHandler(action);

    return next(action);
  };
};

export default createCookieMiddleware;
